import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

// Component
import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';
// Modules

import { CoreModule } from './core/core.module';
import { ShellModule } from './shell/shell.module';
import { LeftSideNavigationExampleComponent } from './left-side-navigation-example/left-side-navigation-example.component';

@NgModule({
  declarations: [
    AppComponent,
    LeftSideNavigationExampleComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    CoreModule,
    ShellModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
  providers: [],
  bootstrap: [
    AppComponent
  ],
  exports: [
  ]
})
export class AppModule { }
